import { connect } from 'react-redux';
import OrgCollectionHomepage from '../components/org_collection_homepage';
import actions from '../redux/actions';

function mapStateToProps(state: any) {
    const { user } = state.user;
    const { layoutTitles } = state.samaritan;
    const { incomingCareCoordinatorReferrals, isFetchingIncomingCareCoordinatorReferrals } = state.referrals;

    return {
        user,
        layoutTitles,
        incomingCareCoordinatorReferrals,
        isFetchingIncomingCareCoordinatorReferrals
    };
}

const mapDispatchToProps = {
    setLayoutTitles: actions.setLayoutTitles,
    resetCatchUpItemStatus: actions.resetCatchUpItemStatus,
    resetHomelessInfo: actions.resetHomelessInfo,
    resetMessageInfo: actions.resetMessageInfo,
    resetMemberReferrals: actions.resetMemberReferrals,
    resetTouchpointAnswers: actions.resetTouchpointAnswers,
    resetUnenrollmentState: actions.resetUnenrollmentState,
    saveMemberToMyMembers: actions.saveMemberToMyMembers,
    removeMemberFromMyMembers: actions.removeMemberFromMyMembers,
    fetchIncomingCareCoordinatorReferrals: actions.fetchIncomingCareCoordinatorReferralsRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgCollectionHomepage);